var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import Button from 'antd/es/button';
import { Typography } from 'antd';
import Icon from '@ant-design/icons';
import { ReactComponent as QuickRepliesPlus } from '../../assets/icons/plus/quickRepliesPlus.svg';
import classNames from 'classnames';
import { Trans } from 'react-i18next';
import i18n from '../../i18n';
import NotificationModal from '../Chat/common/NotificationModal';
import { getDirection } from '../../helpers';
import { SelectOutlined } from '@ant-design/icons';
import EntityList from './components/EntityList';
import Header from './components/Header';
import EntityDelete from './components/EntityDelete';
import EntityFormWrap from './components/EntityFormWrap';
import styles from './EntityManager.module.scss';
const { Text } = Typography;
export var Operation;
(function (Operation) {
    Operation[Operation["LIST"] = 1] = "LIST";
    Operation[Operation["CREATE"] = 2] = "CREATE";
    Operation[Operation["EDIT"] = 3] = "EDIT";
    Operation[Operation["DELETE"] = 4] = "DELETE";
})(Operation || (Operation = {}));
class EntityManager extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "handleFormInput", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.setState({ error: null });
            }
        });
        Object.defineProperty(this, "componentDidMount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (typeof this.props.onMounted === 'function') {
                    this.props.onMounted().catch((error) => {
                        console.error(error);
                    });
                }
            }
        });
        Object.defineProperty(this, "componentWillUnmount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (typeof this.props.onClose === 'function') {
                    this.props.onClose();
                }
            }
        });
        Object.defineProperty(this, "render", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: classNames(styles.managerContents, {
                            [styles.rtl]: this.props.isRTL,
                        }) },
                        React.createElement(Header, Object.assign({ operation: this.props.operationProp || Operation.LIST, title: this.props.renderOperationTitle(this.props.operationProp || Operation.LIST, this.props.currentEntityProp || undefined), onMobileBack: this.props.onMobileBack, isRTL: this.props.isRTL }, this.props.headerProps)),
                        React.createElement("div", { className: styles.contentWrapper }, this.renderContents())),
                    React.createElement(NotificationModal, { visible: this.state.notifyModalVisible, contentText: this.state.notifyModalText || '', onCancel: () => this.closeNotifyModal() })));
            }
        });
        Object.defineProperty(this, "renderContents", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { error } = this.state;
                const operation = this.props.operationProp || Operation.LIST;
                const currentEntity = this.props.currentEntityProp;
                if (operation === Operation.LIST && !currentEntity) {
                    return (React.createElement("div", { className: styles.emptyStatePlaceholder },
                        React.createElement(SelectOutlined, { className: styles.emptyStateIcon }),
                        React.createElement(Text, { type: "secondary", className: styles.emptyStateText },
                            React.createElement(Trans, { i18nKey: "selectOrCreate", defaults: "Select an item from the list to view or edit, or create a new one." }))));
                }
                return (React.createElement(React.Fragment, null,
                    (Operation.CREATE === operation || (Operation.EDIT === operation && currentEntity)) && (React.createElement(EntityFormWrap, { form: this.props.form, additionalProps: this.props.formProps, loading: this.props.loading, entity: currentEntity, onSave: (formData) => this.saveEntity(formData), onCancel: () => this.props.onCancelForm && this.props.onCancelForm(), onInput: this.handleFormInput, error: error, saveButtonText: operation === Operation.CREATE ? (React.createElement(Trans, { i18nKey: "create" })) : (React.createElement(Trans, { i18nKey: "save" })) })),
                    Operation.DELETE === operation && currentEntity && (React.createElement(EntityDelete, { loading: this.props.loading, entity: currentEntity, question: this.props.renderDeleteQuestion(currentEntity), onContinue: () => this.deleteEntity(), onCancel: () => this.props.onCancelForm && this.props.onCancelForm(), error: error }))));
            }
        });
        Object.defineProperty(this, "saveEntity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (formData) => {
                var _a;
                if (!this.props.onEntitySave)
                    return;
                this.props
                    .onEntitySave(formData, (_a = this.props.currentEntityProp) !== null && _a !== void 0 ? _a : undefined)
                    .then((result) => {
                    if (result === false) {
                        return; // Save was cancelled by the handler
                    }
                    if (this.props.onSaveCompleted)
                        this.props.onSaveCompleted();
                    this.openNotifyModal('savedSuccessfully');
                })
                    .catch((error) => {
                    this.setState({ error: error.message || i18n.t('unexpectedError') });
                });
            }
        });
        Object.defineProperty(this, "deleteEntity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                if (!this.props.currentEntityProp || !this.props.onEntityDelete)
                    return;
                this.props
                    .onEntityDelete(this.props.currentEntityProp)
                    .then(() => {
                    if (this.props.onDeleteCompleted)
                        this.props.onDeleteCompleted();
                    this.openNotifyModal('deletedSuccessfully');
                })
                    .catch((error) => {
                    this.setState({ error: error.message || i18n.t('unexpectedError') });
                });
            }
        });
        Object.defineProperty(this, "openNotifyModal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (notifyModalText) => {
                this.setState({ notifyModalVisible: true, notifyModalText });
            }
        });
        Object.defineProperty(this, "closeNotifyModal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.setState({ notifyModalVisible: false, notifyModalText: '' });
            }
        });
        this.state = {
            notifyModalVisible: false,
            notifyModalText: null,
            error: null,
        };
    }
}
Object.defineProperty(EntityManager, "defaultProps", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: {
        loading: false,
    }
});
export default EntityManager;
export function EntityManagerRoute(_a) {
    var props = __rest(_a, []);
    const [currentOperation, setCurrentOperation] = React.useState(Operation.LIST);
    const [currentEntity, setCurrentEntity] = React.useState(null);
    const isRTL = getDirection() === 'rtl';
    const switchToListMode = () => {
        setCurrentOperation(Operation.LIST);
        setCurrentEntity(null);
        if (props.onEntityCancel) {
            props.onEntityCancel();
        }
    };
    const switchToCreateMode = () => {
        if (props.customAction) {
            props.customAction();
            return;
        }
        setCurrentOperation(Operation.CREATE);
        setCurrentEntity(null);
    };
    const switchToEditMode = (entity) => {
        setCurrentOperation(Operation.EDIT);
        setCurrentEntity(entity);
    };
    const switchToDeleteMode = (entity) => {
        console.log('EntityManagerRoute: switchToDeleteMode called with entity:', entity);
        setCurrentOperation(Operation.DELETE);
        setCurrentEntity(entity);
    };
    const { entities, teaser, teaserProps, entityIdKey, disabled, renderOperationTitle, opSupported, sorter, customListActions, customActionIcons, renderListItem, loading, } = props;
    const createTitle = renderOperationTitle(Operation.CREATE);
    const listTitle = renderOperationTitle(Operation.LIST);
    const isDetailsActiveMobile = currentOperation === Operation.CREATE ||
        currentOperation === Operation.EDIT ||
        currentOperation === Operation.DELETE;
    return (React.createElement("div", { className: classNames(styles.entityManagerLayout, { [styles.detailsVisibleMobile]: isDetailsActiveMobile }, { [styles.rtl]: isRTL }) },
        React.createElement("div", { className: classNames(styles.sidebar, { [styles.rtl]: isRTL }) },
            React.createElement("div", { className: styles.sidebarListHeader },
                React.createElement("span", null, listTitle),
                (!opSupported || opSupported.includes(Operation.CREATE)) && (React.createElement(Button, { type: "text", icon: React.createElement(Icon, { component: QuickRepliesPlus }), onClick: switchToCreateMode, className: styles.actionButton }))),
            React.createElement(EntityList, { entities: entities, loading: loading, teaser: teaser, additionalProps: teaserProps, entityIdKey: entityIdKey, disabled: disabled, createTitle: createTitle, onCreate: !opSupported || opSupported.includes(Operation.CREATE) ? switchToCreateMode : undefined, onEdit: !opSupported || opSupported.includes(Operation.EDIT) ? switchToEditMode : undefined, onDelete: !opSupported || opSupported.includes(Operation.DELETE) ? switchToDeleteMode : undefined, sorter: sorter, customListActions: customListActions, customActionIcons: customActionIcons, renderListItem: renderListItem, currentOperation: currentOperation, selectedEntityId: currentOperation === Operation.EDIT && currentEntity ? currentEntity[entityIdKey] : null })),
        React.createElement("div", { className: styles.contentArea },
            React.createElement(EntityManager, Object.assign({}, props, { operationProp: currentOperation, currentEntityProp: currentEntity || undefined, onSaveCompleted: switchToListMode, onDeleteCompleted: switchToListMode, onCancelForm: switchToListMode, onMobileBack: switchToListMode, isRTL: isRTL, key: `entity-manager-${currentOperation}-${currentEntity ? currentEntity[entityIdKey] : 'no-entity'}` })))));
}
